module.exports = __webpack_public_path__ + "593a3d53/img/arrow-share-icon.00a12c29.svg";